"use client";
import Link from "next/link";
import Image from "next/image";
import { QrCode } from "lucide-react";
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from "@/app/components/shadcn/tooltip";
import { FooterApps } from "@/app/lib/features/footer/footer.types";
import { trackGeneric } from "@/app/lib/tracking/interactions";

interface FooterMobileAppsProps {
  apps: FooterApps;
}

const FooterMobileApps = ({ apps }: FooterMobileAppsProps) => {
  return (
    <div className="space-y-1 lg:space-y-2">
      <h2 className="text-sm sm:text-base lg:text-lg transition-all duration-300 ease-in-out hover:text-main font-medium">
        {apps.title}
      </h2>
      <div className="flex items-start gap-3">
        {apps.items.map((app) => (
          <div key={app.key}>
            <div className="hidden lg:block">
              <Tooltip>
                <TooltipTrigger asChild>
                  <Link
                    href={app.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => trackGeneric(`app_store_${app.key}`)}
                    className="w-7.5 h-7.5 flex items-center justify-center hover:opacity-80 transition-opacity"
                  >
                    <Image
                      src={app.icon}
                      alt={app.title}
                      width={30}
                      height={30}
                    />
                  </Link>
                </TooltipTrigger>
                <TooltipContent variant="white" side="top">
                  <div className="w-24 h-24 flex items-center justify-center">
                    {app.qr_code ? (
                      <Image
                        src={app.qr_code}
                        alt={`${app.title} QR`}
                        width={96}
                        height={96}
                        className="object-contain"
                      />
                    ) : (
                      <div className="w-16 h-16 bg-white p-2 rounded-lg border border-neutral-200 flex items-center justify-center">
                        <QrCode size={40} className="text-neutral-400" />
                      </div>
                    )}
                  </div>
                </TooltipContent>
              </Tooltip>
            </div>
            <div className="block lg:hidden">
              <Link
                href={app.url}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackGeneric(`app_store_${app.key}`)}
                className="w-7.5 h-7.5 flex items-center justify-center hover:opacity-80 transition-opacity"
              >
                <Image
                  src={app.icon}
                  alt={app.title}
                  width={30}
                  height={30}
                />
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FooterMobileApps;
